/**
 * Canonical moment.js format tokens shared across the app. This is the single
 * source of truth; `components/Common.js` and `components/common/util.js`
 * re-export from here for backward compatibility.
 */

export const MomentTimeFormat = {
    TwentyFourHourNoLeading: 'H:mm',
    TwentyFourHourWithLeading: 'HH:mm',
    TwelveHourWithLeading: 'hh:mm',
    TwelveHourNoLeading: 'h:mm',
    AnteTwentyFourHour: 'H:mm A',
    AnteTwelveHour: 'h:mm A',
} as const;

export const MomentDateFormat = {
    DateOnlyUTCHyphenated: 'YYYY-MM-DD',
    DateOnlyUTCSlashes: 'YYYY/MM/DD',
    MonthDayYearHyphensNoLeading: 'M-DD-YYYY',
    MonthDayYearHyphensLeading: 'MM-DD-YYYY',
    MonthDayYearSlashesNoLeading: 'M/DD/YYYY',
    MonthDayYearSlashesLeading: 'MM/DD/YYYY',
    DateTimeShortAnte: 'M/D/YY, h:mm A',
    DateTimeShortWeekDayAnte: 'M/D/YYYY ddd, h:mm A',
    DateTimeLongAnte: 'MMMM D, YYYY [at] h:mm A',
    DateTimeISO8601: 'YYYY-MM-DDTHH:mm:ssZ',
    DateTimeISO8601Short: 'YYYY-MM-DDTHH:mm:ss',
} as const;

/** Default full date-time format (`YYYY-MM-DD HH:mm:ss`). */
export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
